


























import Vue from 'vue';
import ProductTypeCard from '@/web/components/products/ProductTypeCard.vue';
import { mapGetters } from 'vuex';
import { notify } from '@/web/utils/notify';
import { getConfig } from '@/web/utils/configuration';
import TeacherPermissionsMixin from '@/web/mixins/TeacherPermissionsMixin';
import { HMUpgradePlanModal } from '@/web/components/common';

interface ProductTypeCard {
  icon: string;
  title: string;
  subtitle: string;
  name: string;
}

interface LocalState {
  isLoading: boolean;
}

export default Vue.extend({
  name: 'CreateProductModal',
  components: { ProductTypeCard },
  computed: {
    ...mapGetters({
      productForm: 'product/productForm',
    }),
    productTypeCards() {
      return [
        {
          icon: getConfig()['product-membership-img'],
          title: this.$t(
            'PRODUCTS.NEW_PRODUCT_LABELS.ON_DEMAND_LIBRARY'
          ) as string,
          subtitle: this.$t(
            'PRODUCTS.NEW_PRODUCT_LABELS.ON_DEMAND_LIBRARY_DESCRIPTION'
          ) as string,
          name: 'media_library',
          productInit: {},
          locked: !this.hasPermission('has_membership_product'),
        },
        {
          icon: '/assets/images/product/course.svg',
          title: this.$t('PRODUCTS.NEW_PRODUCT_LABELS.COURSE') as string,
          subtitle: this.$t(
            'PRODUCTS.NEW_PRODUCT_LABELS.COURSE_DESCRIPTION'
          ) as string,
          name: 'course',
          productInit: {},
          locked: !this.hasPermission('has_course_product'),
        },
        {
          icon: '/assets/images/product/bundle.svg',
          title: this.$t('PRODUCTS.NEW_PRODUCT_LABELS.BUNDLE') as string,
          subtitle: this.$t(
            'PRODUCTS.NEW_PRODUCT_LABELS.BUNDLE_DESCRIPTION'
          ) as string,
          name: 'bundle',
          productInit: {
            product_name: 'New bundle',
          },
          locked: !this.hasPermission('has_bundles'),
        },
        {
          icon: '/assets/images/product/private-coaching.svg',
          title: this.$t(
            'PRODUCTS.NEW_PRODUCT_LABELS.INDIVIDUAL_COACHING'
          ) as string,
          subtitle: this.$t(
            'PRODUCTS.NEW_PRODUCT_LABELS.INDIVIDUAL_COACHING_DESCRIPTION'
          ) as string,
          name: 'private_coaching',
          productInit: {
            has_private_sessions: true,
          },
          locked: !this.hasPermission('has_private_coaching_product'),
        },
        {
          icon: getConfig()['product-classcard-img'],
          title: this.$t('PRODUCTS.NEW_PRODUCT_LABELS.CLASS_CARD') as string,
          subtitle: this.$t(
            'PRODUCTS.NEW_PRODUCT_LABELS.CLASS_CARD_DESCRIPTION'
          ) as string,
          name: 'punch_card',
          productInit: {
            pricing_type: 'fixed',
            product_name: 'New ClassCard',
          },
        },
        {
          icon: '/assets/images/product/in-person-only.svg',
          title: this.$t(
            'PRODUCTS.NEW_PRODUCT_LABELS.IN_PERSON_ONLY'
          ) as string,
          subtitle: this.$t(
            'PRODUCTS.NEW_PRODUCT_LABELS.IN_PERSON_ONLY_DESCRIPTION'
          ) as string,
          name: 'event_only',
          productInit: {},
        },
        {
          icon: '/assets/images/product/digital-download.svg',
          title: this.$t(
            'PRODUCTS.NEW_PRODUCT_LABELS.DIGITAL_DOWNLOAD'
          ) as string,
          subtitle: this.$t(
            'PRODUCTS.NEW_PRODUCT_LABELS.DIGITAL_DOWNLOAD_DESCRIPTION'
          ) as string,
          name: 'digital_download',
          productInit: {},
        },
      ];
    },
    sortedProductTypeCards() {
      return [...this.productTypeCards].sort((a, b) => {
        return a.locked ? 1 : b.locked ? -1 : 0;
      });
    },
  },
  mixins: [TeacherPermissionsMixin],
  data(): LocalState {
    return {
      isLoading: false,
    };
  },
  methods: {
    async onCardClick(type): Promise<void> {
      if (type.locked) {
        return this.handleLockedProductClick();
      }
      const createProduct: CreateProductRequest = {
        product_name: 'New product',
        product_type: type.name,
        ...type.productInit,
      };
      this.isLoading = true;
      const product = await this.$store.dispatch(
        'product/createProduct',
        createProduct
      );
      notify(
        this.$t('PRODUCTS.MODAL.PRODUCT_CREATED').toString(),
        this.$t('PRODUCTS.MODAL.PRODUCT_CREATED_DESCRIPTION').toString()
      );
      this.$store.dispatch('product/setProductForm', product);
      this.isLoading = false;
      this.$modal.hideAll();
      this.$router.push(`/products/${product.id}/edit/`);
    },
    handleLockedProductClick() {
      this.$modal.show(HMUpgradePlanModal, {
        description: 'GENERAL.TEXT.UPGRADE_PRODUCT_TYPES',
        onConfirm: () => {
          this.$modal.hideAll();
          this.$router.push({ name: 'settings-adjust-plan' });
        },
      });
    },
  },
});
